import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineExecutionFragment as PipelineExecutionFragmentType} from './__generated/PipelineExecutionFragment';

/**
 * Fragment for PipelineExecutionNode.
 *
 * @deprecated Use steps directly from PipelineFragment instead.
 */
export const PIPELINE_EXECUTION_FRAGMENT = gql`
  fragment PipelineExecutionFragment on PipelineExecutionNode {
    id
    steps {
      id
      modifiedAt
      definition {
        id
        stepType
        stepVersion
        incomingEdges {
          # We can't re-query full definition nodes because GraphQL can't query arbitrary graphs, so instead just
          # get the id of parent (or child), which can be used to lookup steps in the steps list.
          parent {
            id
            step {
              id
            }
          }
          parentStepData {
            id
            name
          }
          childStepData {
            id
            name
          }
        }
        outgoingEdges {
          child {
            id
            step {
              id
            }
          }
          parentStepData {
            id
            name
          }
          childStepData {
            id
            name
          }
        }
      }
      inputStepDatas {
        id
        dataFrames {
          id
          name
          allColumnsJson
        }
        charts {
          ... on ChartNode {
            id
            name
            library
            # Omitted for lazy loading (fetched via GET_CHART_QUERY):
            # libraryConfig, libraryVersion, rasterDownloadUrl, rasterExternalFileId
          }
          ...InaccessibleInfoGraphQL
        }
        scratchFiles {
          ... on ScratchFileNode {
            id
            name
            filename
            externalFileId
            # Omitted for lazy loading (fetched via GET_SCRATCH_FILE_QUERY):
            # downloadUrl, mimeType
          }
          ...InaccessibleInfoGraphQL
        }
        kind
        name
      }
      outputStepDatas {
        id
        dataFrames {
          id
          name
          allColumnsJson
        }
        charts {
          ... on ChartNode {
            id
            name
            library
            # Omitted for lazy loading (fetched via GET_CHART_QUERY):
            # libraryConfig, libraryVersion, rasterDownloadUrl, rasterExternalFileId
          }
          ...InaccessibleInfoGraphQL
        }
        scratchFiles {
          ... on ScratchFileNode {
            id
            name
            filename
            externalFileId
            # Omitted for lazy loading (fetched via GET_SCRATCH_FILE_QUERY):
            # downloadUrl, mimeType
          }
          ...InaccessibleInfoGraphQL
        }
        kind
        name
      }
      statusCode
      statusMessage
      isRerunnable
      nonRerunnableReason
      config {
        variables {
          name
          value
        }
      }
    }
  }
`;

export const PipelineExecutionFragment: FragmentWrapper<PipelineExecutionFragmentType> = {
  fragment: PIPELINE_EXECUTION_FRAGMENT,
  fragmentName: 'PipelineExecutionFragment',
};
